module.exports = __webpack_public_path__ + "static/img/cup_yellow.30063f2d.png";